import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Tenant context injection
let currentOrgId = null;
let currentBranchId = null;

export const setTenantContext = (orgId, branchId) => {
  currentOrgId = orgId;
  currentBranchId = branchId;
};

api.interceptors.request.use((config) => {
  if (currentOrgId) config.headers["X-Organization-Id"] = currentOrgId;
  if (currentBranchId) config.headers["X-Branch-Id"] = currentBranchId;
  return config;
});

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

export const peso = (v) => {
  const n = Number(v ?? 0);
  return "₱" + n.toLocaleString("en-PH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
